<template>
  <section class="empty-cart-teaser">
    <header v-if="hasSlot('header')" class="flex flex-col items-start gap-sm p-md sm:p-lg">
      <slot name="header" />
    </header>
    <div class="empty-cart-teaser--body">
      <article class="shop-sloan-item">
        <SloProductImage :source="[{ src: '/themes/sloan/img/marketplace/shop-soap-dispenser-placeholder.jpg' }]" />
        <section>
          <div>
            <h2>{{ 'Shop Soap Dispensers' | t }}</h2>
            <p class="description">{{ 'Touch-free soap dispensers for hygienic, stylish restrooms.' | t }}</p>
          </div>
          <div>
            <SloButton href="/commercial-bathroom-products/soap-dispensers/browse" fill="outline">
              {{ 'Shop Now' | t }}
            </SloButton>
          </div>
        </section>
      </article>
      <article class="shop-sloan-item">
        <SloProductImage :source="[{ src: '/themes/sloan/img/marketplace/shop-showerhead-placeholder.jpg' }]" />
        <section>
          <div>
            <h2>{{ 'Shop Showerheads' | t }}</h2>
            <p class="description">{{ 'Smart styling for easy commercial installation.' | t }}</p>
          </div>
          <div>
            <SloButton href="/commercial-bathroom-products/water-saving-shower-heads/browse" fill="outline">
              {{ 'Shop Now' | t }}
            </SloButton>
          </div>
        </section>
      </article>
      <article class="shop-sloan-item">
        <SloProductImage :source="[{ src: '/themes/sloan/img/marketplace/shop-parts-placeholder.jpg' }]" />
        <section>
          <div>
            <h2>{{ 'Shop Parts' | t }}</h2>
            <p class="description">{{ 'Genuine replacement parts for Sloan products.' | t }}</p>
          </div>
          <div>
            <SloButton href="/commercial-bathroom-products/parts/browse" fill="outline">
              {{ 'Shop Now' | t }}
            </SloButton>
          </div>
        </section>
      </article>
      <article class="shop-sloan-item">
        <SloProductImage :source="[{ src: '/themes/sloan/img/marketplace/shop-hand-dryers-placeholder.jpg' }]" />
        <section>
          <div>
            <h2>{{ 'Shop Hand Dryers' | t }}</h2>
            <p class="description">{{ 'Overhauled to be faster, quieter, and more efficient.' | t }}</p>
          </div>
          <div>
            <SloButton href="/commercial-bathroom-products/hand-dryers/browse?level=variation" fill="outline">
              {{ 'Shop Now' | t }}
            </SloButton>
          </div>
        </section>
      </article>
      <article class="shop-sloan-item border-b-1 border-gray-400">
        <SloProductImage :source="[{ src: '/themes/sloan/img/marketplace/shop-mirrors-placeholder.jpg' }]" />
        <section>
          <div>
            <h2>{{ 'Shop Mirrors' | t }}</h2>
            <p class="description">{{ 'The perfect reflection of your design.' | t }}</p>
          </div>
          <div>
            <SloButton href="/commercial-bathroom-products/mirrors/browse?level=variation" fill="outline">
              {{ 'Shop Now' | t }}
            </SloButton>
          </div>
        </section>
      </article>
      <article class="shop-sloan-item">
        <SloProductImage :source="[{ src: '/themes/sloan/img/marketplace/shop-faucets-placeholder.jpg' }]" />
        <section>
          <div>
            <h2>{{ 'Shop Faucets' | t }}</h2>
            <p class="description">{{ 'Touch-free faucets for any market and budget.' | t }}</p>
          </div>
          <div>
            <SloButton href="/commercial-bathroom-products/faucets/browse?level=product" fill="outline">
              {{ 'Shop Now' | t }}
            </SloButton>
          </div>
        </section>
      </article>
      <article class="shop-sloan-item">
        <SloProductImage :source="[{ src: '/themes/sloan/img/marketplace/shop-accessories-placeholder.jpg' }]" />
        <section>
          <div>
            <h2>{{ 'Shop Accessories' | t }}</h2>
            <p class="description">{{ 'Enhance your Sloan products with optional add-ons.' | t }}</p>
          </div>
          <div>
            <SloButton href="/commercial-bathroom-products/accessories/browse" fill="outline">
              {{ 'Shop Now' | t }}
            </SloButton>
          </div>
        </section>
      </article>
    </div>
  </section>
</template>

<script>
import t from '../../main/i18n';
import SloProductImage from '../../../lib/components/SloProductImage.vue';
import SloButton from '../../../lib/components/SloButton.vue';

export default {
  components: {
    SloProductImage,
    SloButton
  },
  filters: {
    t
  },
  methods: {
    hasSlot(name = 'default') {
      return Boolean(this.$slots[name] || this.$scopedSlots[name]);
    }
  }
};
</script>

<style lang="scss">
@import '../../../scss/variables';
@import '../../../scss/system';

.empty-cart-teaser {
  border: 1px solid $color-gray-400;
  border-radius: 1.2rem;

  header {
    border-bottom: 1px solid $gray;
  }

  &--body {
    display: grid;

    @media (min-width: $screen-md) {
      grid-template-columns: repeat(2, 1fr);
    }

    .shop-sloan-item {
      display: flex;
      padding: 24px;
      gap: 24px;

      @media (min-width: $screen-md) {
        &:nth-child(odd) {
          border-right: 1px solid $gray;
        }
      }

      &:not(:nth-last-child(-n+2)) {
        border-bottom: 1px solid $gray;
      }

      div:nth-child(3) {
        flex: none;
      }

      &:nth-child(6) {
        border-bottom: 1px solid $gray;
      }

      img {
        width: 130px;
        border-radius: 8px;
      }

      section {
        display: flex;
        flex: 1;
        flex-direction: column;
        gap: 24px;

        @media (min-width: $screen-md) {
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
        }

        @media (min-width: 1300px) {
          flex-wrap: nowrap;
        }

        h2 {
          font-weight: $font-weight-medium;
          font-size: $font-size-base;
        }

        a {
          min-width: 110px;
        }

        .description {
          display: none;

          @media (min-width: $screen-md) {
            display: block;
          }
        }
      }
    }
  }
}
</style>
